
<invite-user
  id="invite-user"
  :email-addresses="emailAddresses"
  :loading="loading"
  @onSendInvite="sendInvite"
>
</invite-user>
